<template>
  <div>
    <h2 style="float: left;">
      Новости
    </h2>
    <publications
      type="news"
      detail-route-name="NewsDetail"
    />
  </div>
</template>

<script>
import Publications from '../components/Publications'

export default {
  name: 'News',
  components: { Publications }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
}
</style>
